/* eslint-disable react-hooks/exhaustive-deps */
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { WidgetLoader } from 'datastake-daf/dist/components';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Map from './map';
import Flow from './flow';
import Style from './style';
import Widget from '../../widget';
import { getTabs } from './helper';
import spProject from '../../../../../store/hardcoded-sp';
import DashboardPopover from '../../../components/Popover';
import useFetchHelper from '../../../../../helpers/useFetchHelper';

const SupplyChain = ({
  data: allData = {},
  isLoading = false,
  datastakeId = '',
  supplyChainMapCallback = () => { },
  projectData,
  openSettings = () => { },
  filterKey,
}) => {
  const ref = useRef();
  const { t } = useTranslation();
  const tabs = useMemo(() => getTabs(t), [t]);
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const [showMap, setShowMap] = useState(false);
  const { canFetch } = useFetchHelper({ ref });

  useEffect(() => {
    if (filterKey === '1b') {
      setActiveTab(tabs[0].key);
    }

    if (filterKey === '2b') {
      if (!showMap) {
        setShowMap(true);
      }
      setActiveTab(tabs[1].key);
    }
  }, [filterKey])


  const data = { ...allData, ...spProject };

  return (
    <div ref={ref} className="flex-row flex-1" id="1b">
      <Widget
        title={t('Mineral Supply Chain')}
        withBorderHeader={false}
        loading={isLoading}
        tooltip={(
          <DashboardPopover
            title={t('Material Flow')}
            body={t('Supply chain actors and associated mine sites, based on your selection.')}
            action={(
              <a onClick={openSettings}>
                {t('Data Settings')}
              </a>
            )}
          />
        )}
        className="no-pb-header"
      >
        {isLoading && (
          <WidgetLoader background="white" />
        )}
        <Style>
          <div className="flex-row">
            <div className="flex-1" />
            <div>
              <Tabs
                className="header-tab-cont"
                defaultActiveKey={activeTab}
                activeKey={activeTab}
                onChange={(a) => {
                  setActiveTab(a);
                  if (a === 'map') {
                    setShowMap(true);
                  }
                }}
                items={(tabs || []).map((t) => ({
                  label: t.label,
                  key: t.key
                }))}
              >
              </Tabs>
            </div>
          </div>
          <div style={{ display: activeTab === 'flow' ? 'block' : 'none' }}>
            <Flow
              openSettings={openSettings}
              canFetch={canFetch}
              trade={data.trade}
              datastakeId={datastakeId}
              scm={data.scm}
              supplyChainMapCallback={supplyChainMapCallback}
              projectData={projectData}
            />
          </div>
          {showMap && (
            <div style={{ display: activeTab === 'map' ? 'flex' : 'none', flex: 1 }}>
              <Map t={t} />
            </div>
          )}
        </Style>
      </Widget >
    </div >
  );
};

export default SupplyChain;
